import { SHORT_COMPLIANCE_NOTICE } from './legal';

export const programmes = [
  {
    id: 'foundation',
    name: 'Foundation Financial Wellbeing',
    price: '£2,995',
    eligibility: 'For organisations with up to 250 employees.',
    strapline: 'A low-risk way to start financial wellbeing in your organisation.',
    whoItsFor: 'Organisations piloting financial wellbeing before a wider rollout.',
    includesHeading: "What's included:",
    features: [
      'Weekly financial wellbeing email content for your staff (52 emails per year)',
      '4 interactive webinars or workshops per year, one per quarter. Each lasts 45-60 minutes and is delivered online (in-person by arrangement, with travel at cost)',
      'Access to our core financial wellbeing content library',
      '2 personal finance awareness campaigns per year',
      'A short annual impact summary covering attendance, engagement and participant feedback',
    ],
    excluded: 'Financial advice, individual one-to-one support, or workforce surveys (these are in the Growth tier).',
    cta: 'Book a free session',
    notice: SHORT_COMPLIANCE_NOTICE,
  },
  {
    id: 'growth',
    name: 'Growth & Engagement Programme',
    badge: 'Recommended',
    price: '£7,500',
    eligibility: 'For organisations with up to 500 employees.',
    strapline: 'Measurable impact and sustained engagement across the year.',
    whoItsFor: 'Mid-sized employers and universities that want data to show the impact of financial wellbeing.',
    includesHeading: 'Everything in Foundation, plus (totals shown):',
    features: [
      '6 live sessions per year in total: 4 webinars or workshops, plus 2 masterclasses or expert workshops',
      '4 campaigns and awareness weeks per year in total',
      'An anonymous financial wellbeing health survey, with results reported in aggregate only',
      'A quarterly financial health summary report, drawing on attendance, engagement, survey results and short pulse questions',
      'Branded financial wellbeing content for your internal communications',
      'Weekly email content and content library access (as in Foundation)',
    ],
    universities: 'Sessions and surveys can be run separately for staff and for students.',
    excluded: 'Financial advice, individual one-to-one support, or a bespoke strategy (included in the Strategic tier).',
    cta: 'Book a free session',
    notice: 'Survey responses are anonymous and reported in aggregate only, in line with UK GDPR. GenMoney is a financial education company. We do not provide financial advice and are not regulated by the FCA.',
  },
  {
    id: 'strategic',
    name: 'Strategic Financial Wellbeing Partnership',
    price: '£12,000',
    eligibility: 'For organisations with up to 1,000 employees. Larger organisations and universities: price confirmed after a free discovery call.',
    strapline: 'Financial wellbeing built into your people, inclusion and ESG strategy.',
    whoItsFor: 'Larger organisations and universities that want financial wellbeing built into retention, inclusion and social value goals.',
    includesHeading: 'Everything in Growth, plus (totals shown):',
    features: [
      '8 live sessions per year in total (webinars, workshops and masterclasses)',
      'Up to 2 custom campaigns aligned to your organisational priorities, in addition to the 4 standard campaigns',
      'A bespoke financial wellbeing strategy aligned with your HR and ESG goals',
      'Quarterly strategy and insights calls',
      'A full annual financial wellbeing impact report',
      'A named programme lead and priority email support',
    ],
    excluded: 'Financial advice or individual one-to-one support.',
    cta: 'Book a free discovery call',
    notice: SHORT_COMPLIANCE_NOTICE,
  },
];